// src/components/Payment/addbanner.js
import React from 'react';

const Customerlist = () => {
  return (
    <div>
      <h2>customerlist</h2>
      <p>This is the addbanner component.</p>
    </div>
  );
};

export default Customerlist;
